module.exports = __webpack_public_path__ + "media/images/top/img_pickup_tsujita-189c337104abfe31ac407d7616d1b03b.webp";